
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.b1738753113 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b188880793 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b1025930803 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a9205588 = numberParserFn([{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.a1289977499 = pluralGeneratorFn(function(n
) {
  return 'other';
});
Globalize.b790620617 = messageFormatterFn((function(  ) {
  return function(d) { return "登录"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a346058995 = messageFormatterFn((function(  ) {
  return function(d) { return "登录"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1383276696 = messageFormatterFn((function(  ) {
  return function(d) { return "邮箱地址"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1404941761 = messageFormatterFn((function(  ) {
  return function(d) { return "密码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a2073618912 = messageFormatterFn((function(  ) {
  return function(d) { return "这是公共或共享设备"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1794169191 = messageFormatterFn((function(  ) {
  return function(d) { return "不是您的设备？选中此复选框可减少您在此处登录的时间。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1254815116 = messageFormatterFn((function(  ) {
  return function(d) { return "保持登录"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1863114602 = messageFormatterFn((function(  ) {
  return function(d) { return "选中此复选框将使您在该设备上保持帐户登录状态，直到您退出。请勿在共享设备上选择此项。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a944688706 = messageFormatterFn((function(  ) {
  return function(d) { return "忘记密码？"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1089971251 = messageFormatterFn((function(  ) {
  return function(d) { return "继续"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1187348448 = messageFormatterFn((function(  ) {
  return function(d) { return "取消"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a816251753 = messageFormatterFn((function(  ) {
  return function(d) { return "返回"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1089009429 = messageFormatterFn((function(  ) {
  return function(d) { return "重新加载"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a408677552 = messageFormatterFn((function(  ) {
  return function(d) { return "登录即表示，我同意 " + d["0"] + " <a href=" + d["1"] + " " + d["3"] + ">条款和条件</a>和<a href=" + d["2"] + " " + d["4"] + ">隐私声明</a>。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1862730162 = messageFormatterFn((function(  ) {
  return function(d) { return "登录即表示，我同意 " + d["0"] + " <a href=" + d["1"] + " " + d["5"] + ">条款和条件</a>、<a href=" + d["2"] + " " + d["6"] + ">隐私声明</a>和 <a href=" + d["3"] + " " + d["7"] + ">" + d["4"] + " 条款和条件</a>。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1773991462 = messageFormatterFn((function(  ) {
  return function(d) { return "登录即表示，我也将加入 " + d["4"] + "。我同意 " + d["0"] + " <a href=" + d["1"] + " " + d["5"] + ">条款和条件</a>、<a href=" + d["2"] + " " + d["6"] + ">隐私声明</a>和 <a href=" + d["3"] + " " + d["7"] + ">" + d["4"] + " 条款和条件</a>。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1929510405 = messageFormatterFn((function(  ) {
  return function(d) { return "您的帐户在例行安全检查中被暂停使用。您的信息很安全，但需要重置密码。请使用下方的“忘记密码？”链接，登录并修改密码。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a2053774735 = messageFormatterFn((function(  ) {
  return function(d) { return "电子邮箱和密码不匹配。请再试一次。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b578917268 = messageFormatterFn((function(  ) {
  return function(d) { return "抱歉，我们这里出现了一点问题。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1803891214 = messageFormatterFn((function(  ) {
  return function(d) { return "抱歉，我们这边出了一点问题。请稍等片刻，然后重试。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1448692976 = messageFormatterFn((function(  ) {
  return function(d) { return "请输入您的邮箱地址。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a688587425 = messageFormatterFn((function(  ) {
  return function(d) { return "请输入有效的邮箱地址。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1417809721 = messageFormatterFn((function(  ) {
  return function(d) { return "请输入您的密码。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a558433123 = messageFormatterFn((function(  ) {
  return function(d) { return "正在检查登录信息"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1105658878 = messageFormatterFn((function(  ) {
  return function(d) { return "隐藏密码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b791316739 = messageFormatterFn((function(  ) {
  return function(d) { return "显示密码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1540175199 = messageFormatterFn((function(  ) {
  return function(d) { return "没有帐户？<span><a id=\"createAcctRedirectLink\" href=" + d["0"] + ">立即注册</a></span>"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1708112358 = messageFormatterFn((function(  ) {
  return function(d) { return "登录"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a490323715 = messageFormatterFn((function(  ) {
  return function(d) { return "不可以再通过 " + d["0"] + " 登录"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b790502489 = messageFormatterFn((function(  ) {
  return function(d) { return "您可以使用相同的邮箱、重置密码以访问您的 " + d["0"] + " 帐户。这不会影响您的 " + d["1"] + " 帐户。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b132503275 = messageFormatterFn((function(  ) {
  return function(d) { return "使用以下按钮重置您的密码。下次使用您的邮箱和新密码即可直接登录 " + d["0"] + "。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1015084402 = messageFormatterFn((function(  ) {
  return function(d) { return "SSO 登录"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b442361258 = messageFormatterFn((function(  ) {
  return function(d) { return "使用单点登录"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a920869470 = messageFormatterFn((function(  ) {
  return function(d) { return "或使用您的 " + d["0"] + " 帐户"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1825989487 = messageFormatterFn((function(  ) {
  return function(d) { return "赚积分兑换免费行程。会员价省更多。轻松查看行程。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b4599637 = messageFormatterFn((function(  ) {
  return function(d) { return "行程结束后可累积 " + d["0"] + " 个 Expedia Rewards 积分。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1560540504 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " 帐户登录"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a176959494 = messageFormatterFn((function(  ) {
  return function(d) { return "忘记密码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1925597775 = messageFormatterFn((function(  ) {
  return function(d) { return "重置您的密码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1784393131 = messageFormatterFn((function(  ) {
  return function(d) { return "请输入邮箱地址，我们将为您发送密码重置链接。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a17971447 = messageFormatterFn((function(  ) {
  return function(d) { return "发送重置链接"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1493549708 = messageFormatterFn((function(  ) {
  return function(d) { return "检查您的收件箱"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a667791924 = messageFormatterFn((function(  ) {
  return function(d) { return "我们已将含有重置密码链接的邮件发送至 " + d["0"] + "。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a667792885 = messageFormatterFn((function(  ) {
  return function(d) { return "您可能会在几分钟后收到邮件。如果 10 分钟后仍未收到，请检查垃圾邮件文件夹。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1232397567 = messageFormatterFn((function(  ) {
  return function(d) { return "重新发送链接"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b768785065 = messageFormatterFn((function(  ) {
  return function(d) { return "已发送新链接。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1504101078 = messageFormatterFn((function(  ) {
  return function(d) { return "正在验证帐户"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b179312554 = messageFormatterFn((function(  ) {
  return function(d) { return "设置密码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1532975969 = messageFormatterFn((function(  ) {
  return function(d) { return "欢迎回来"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a615550629 = messageFormatterFn((function(  ) {
  return function(d) { return "请设置一个没有使用过的密码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b500281552 = messageFormatterFn((function(  ) {
  return function(d) { return "成功！"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1710368883 = messageFormatterFn((function(  ) {
  return function(d) { return "现在请使用新密码以继续。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a667605016 = messageFormatterFn((function(  ) {
  return function(d) { return "重置密码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a350920613 = messageFormatterFn((function(  ) {
  return function(d) { return "很抱歉，但该请求已超时。如果仍需变更密码，请点击下方以发送新密码重置电子邮件。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1083078155 = messageFormatterFn((function(  ) {
  return function(d) { return "重新发送链接"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b75644896 = messageFormatterFn((function(  ) {
  return function(d) { return "正在保存您的密码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1861529068 = messageFormatterFn((function(  ) {
  return function(d) { return "注册帐户"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1981986304 = messageFormatterFn((function(  ) {
  return function(d) { return "注册帐户"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b365066773 = messageFormatterFn((function(  ) {
  return function(d) { return "邮箱地址"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1543448931 = messageFormatterFn((function(  ) {
  return function(d) { return "请输入您的邮箱地址。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1022113740 = messageFormatterFn((function(  ) {
  return function(d) { return "请输入有效的邮箱地址。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1123808886 = messageFormatterFn((function(  ) {
  return function(d) { return "名字"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1708601602 = messageFormatterFn((function(  ) {
  return function(d) { return "请输入您的名字。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a722672916 = messageFormatterFn((function(  ) {
  return function(d) { return "姓氏"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a536946332 = messageFormatterFn((function(  ) {
  return function(d) { return "请输入您的姓氏。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1117645547 = messageFormatterFn((function(  ) {
  return function(d) { return "姓名栏只能输入拼音/字母。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1573055374 = messageFormatterFn((function(  ) {
  return function(d) { return "密码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1387328790 = messageFormatterFn((function(  ) {
  return function(d) { return "请输入您的密码。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b347170651 = messageFormatterFn((function(  ) {
  return function(d) { return "请输入有效的密码。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b53301957 = messageFormatterFn((function(  ) {
  return function(d) { return "包含 9-64 个字符"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b53300996 = messageFormatterFn((function(  ) {
  return function(d) { return "结合字母和数字"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b53300035 = messageFormatterFn((function(  ) {
  return function(d) { return "特殊字符，如：~ " + "#" + " @ $ % & ! * _ ? ^ -"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b53299074 = messageFormatterFn((function(  ) {
  return function(d) { return "密码不能包含空格"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a66258779 = messageFormatterFn((function(  ) {
  return function(d) { return "密码长度必须在 8 到 64 个字符之间。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a203771080 = messageFormatterFn((function(  ) {
  return function(d) { return "密码不能与您的邮箱地址完全相同。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1368257659 = messageFormatterFn((function(  ) {
  return function(d) { return "密码不能包含空格。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a94935933 = messageFormatterFn((function(  ) {
  return function(d) { return "注册帐户即表示，我同意 " + d["0"] + " <a href=" + d["1"] + " " + d["3"] + ">条款和条件</a>和<a href=" + d["2"] + " " + d["4"] + ">隐私声明</a>。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a450856965 = messageFormatterFn((function(  ) {
  return function(d) { return "注册帐户即表示，我同意 " + d["0"] + " <a href=" + d["1"] + " " + d["5"] + ">条款和条件</a>、<a href=" + d["2"] + " " + d["6"] + ">隐私声明</a>和 <a href=" + d["3"] + " " + d["7"] + ">" + d["4"] + " 条款和条件</a>。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a637792486 = messageFormatterFn((function(  ) {
  return function(d) { return "我希望收到 " + d["0"] + " 通过邮件发送的旅游优惠、特价促销及其他信息。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1281304759 = messageFormatterFn((function(  ) {
  return function(d) { return "我希望收到 " + d["0"] + " 通过邮件发送的旅游优惠、特价促销及其他信息。可随时退订促销邮件。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a2045387689 = messageFormatterFn((function(  ) {
  return function(d) { return "我希望收到 " + d["0"] + " 通过邮件发送的度假推荐、特价促销及其他信息。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1026786970 = messageFormatterFn((function(  ) {
  return function(d) { return "我希望收到 " + d["0"] + " 通过邮件发送的度假推荐、特价促销及其他信息。可随时退订促销邮件。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b921857638 = messageFormatterFn((function(  ) {
  return function(d) { return "继续"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a10239033 = messageFormatterFn((function(  ) {
  return function(d) { return "已有帐户？<span><a id=\"signinRedirectLink\" href=" + d["0"] + ">登录</a></span>"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1118531044 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "，欢迎您！"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b820983838 = messageFormatterFn((function(  ) {
  return function(d) { return "有了您的 " + d["0"] + " 新帐户，世界触手可及。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a747396139 = messageFormatterFn((function(  ) {
  return function(d) { return "继续"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b982124538 = messageFormatterFn((function(  ) {
  return function(d) { return "您需要设置强度更高的密码才可继续"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a2040716363 = messageFormatterFn((function(  ) {
  return function(d) { return "至少包含 8 个字符"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1640059375 = messageFormatterFn((function(  ) {
  return function(d) { return "密码强度"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a232946291 = messageFormatterFn((function(  ) {
  return function(d) { return "弱"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1232869934 = messageFormatterFn((function(  ) {
  return function(d) { return "强"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b795238104 = messageFormatterFn((function(  ) {
  return function(d) { return "很强"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a247945533 = messageFormatterFn((function(  ) {
  return function(d) { return "避免使用可预测的替换字母，例如用“@”代替“a”"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1589650459 = messageFormatterFn((function(  ) {
  return function(d) { return "避免使用常见单词的反向拼写"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1126508659 = messageFormatterFn((function(  ) {
  return function(d) { return "对部分（而非全部）字母使用大写"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a954882708 = messageFormatterFn((function(  ) {
  return function(d) { return "避免只对首字母使用大写"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a2075907272 = messageFormatterFn((function(  ) {
  return function(d) { return "避免使用与您相关的日期及年份"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a105078014 = messageFormatterFn((function(  ) {
  return function(d) { return "避免使用最近的年份"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b663994919 = messageFormatterFn((function(  ) {
  return function(d) { return "避免使用与您相关的年份"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1416791052 = messageFormatterFn((function(  ) {
  return function(d) { return "避免使用常见的字符组合"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1993195854 = messageFormatterFn((function(  ) {
  return function(d) { return "避免使用重复的字母或字符"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1176549838 = messageFormatterFn((function(  ) {
  return function(d) { return "使用更为多样化的字符组合，并变化排列顺序"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a49252951 = messageFormatterFn((function(  ) {
  return function(d) { return "使用更多不太常用的字符组合"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a12800643 = messageFormatterFn((function(  ) {
  return function(d) { return "使用多个字符组合，但避免常用组合"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a51562918 = messageFormatterFn((function(  ) {
  return function(d) { return "无需使用符号、数字或大写字母也可以创建强度较高的密码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1107693139 = messageFormatterFn((function(  ) {
  return function(d) { return "该邮箱地址已存在关联的 " + d["0"] + " 帐户。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1686854015 = messageFormatterFn((function(  ) {
  return function(d) { return "我们已通过电子邮件向您发送注册帐户的链接。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1762358608 = messageFormatterFn((function(  ) {
  return function(d) { return "正在处理注册请求"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1038067044 = messageFormatterFn((function(  ) {
  return function(d) { return "名字（不含姓氏）必须至少为 2 个字符"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1715827502 = messageFormatterFn((function(  ) {
  return function(d) { return "姓氏必须至少为 2 个字符"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a209982794 = messageFormatterFn((function(  ) {
  return function(d) { return "名字（不含姓氏）最大长度为 100 个字符"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b467777664 = messageFormatterFn((function(  ) {
  return function(d) { return "姓氏最大长度为 100 个字符"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a351711685 = messageFormatterFn((function(  ) {
  return function(d) { return "名字（不含姓氏）不能包含特殊字符"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1858940539 = messageFormatterFn((function(  ) {
  return function(d) { return "姓氏不能包含特殊字符"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b2014487453 = messageFormatterFn((function(  ) {
  return function(d) { return "我同意以下所有内容"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a741993775 = messageFormatterFn((function(  ) {
  return function(d) { return "我确认我已年满 18 岁，并且我已查看并同意<a href=" + d["0"] + " " + d["1"] + ">使用条款</a>和 <a href=" + d["2"] + " " + d["3"] + ">" + d["4"] + " 条款和条件</a>（必选）"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1977906829 = messageFormatterFn((function(  ) {
  return function(d) { return "我同意按照<a href=" + d["0"] + " " + d["1"] + ">隐私政策</a>中的说明，收集和使用我的个人信息（必选）"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1065374342 = messageFormatterFn((function(  ) {
  return function(d) { return "我同意按照<a href=" + d["0"] + " " + d["1"] + ">隐私政策</a>中的说明，将我的个人信息提供给第三方，无论是在韩国还是在海外（必选）"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a864696951 = messageFormatterFn((function(  ) {
  return function(d) { return "请接受条款以继续。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a624030771 = messageFormatterFn((function(  ) {
  return function(d) { return "请接受条款以继续。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a381744111 = messageFormatterFn((function(  ) {
  return function(d) { return "请选中此框以继续"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b138676632 = messageFormatterFn((function(  ) {
  return function(d) { return "或注册 " + d["0"] + " 帐户"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1446324950 = messageFormatterFn((function(  ) {
  return function(d) { return "请避免使用空格、您的姓名、邮箱地址或之前曾用过的密码。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1421034310 = messageFormatterFn((function(  ) {
  return function(d) { return "抱歉，我们这边遇到了一点问题。请稍等片刻，然后再试一次。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1116265900 = messageFormatterFn((function(  ) {
  return function(d) { return "验证您的手机号"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1293243235 = messageFormatterFn((function(  ) {
  return function(d) { return "我们会向您的手机号发送一次性验证码，以确保您的帐户安全。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a2053707626 = messageFormatterFn((function(  ) {
  return function(d) { return "发送"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a720810269 = messageFormatterFn((function(  ) {
  return function(d) { return "© " + d["1"] + " " + d["0"] + "，保留所有权利。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b758571925 = messageFormatterFn((function(  ) {
  return function(d) { return "条款和条件"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1823806444 = messageFormatterFn((function(  ) {
  return function(d) { return "隐私政策"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b173865635 = messageFormatterFn((function(  ) {
  return function(d) { return "发短信"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1565524776 = messageFormatterFn((function(  ) {
  return function(d) { return "输入验证码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1927074742 = messageFormatterFn((function(  ) {
  return function(d) { return "验证码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1509215357 = messageFormatterFn((function(  ) {
  return function(d) { return "重新发送验证码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a140985838 = messageFormatterFn((function(  ) {
  return function(d) { return "使用其他手机号"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a261298310 = messageFormatterFn((function(  ) {
  return function(d) { return "已重新发送验证码。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b960953791 = messageFormatterFn((function(  ) {
  return function(d) { return "请输入我们刚发送至 " + d["0"] + " 的 6 位验证码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1178998700 = messageFormatterFn((function(  ) {
  return function(d) { return "正在检查验证码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1174779611 = messageFormatterFn((function(  ) {
  return function(d) { return "验证码有误。重新发送验证码以重试。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1627312693 = messageFormatterFn((function(  ) {
  return function(d) { return "或通过以下帐户登录"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1911442395 = messageFormatterFn((function(  ) {
  return function(d) { return "免费成为会员，预订数千家酒店平均可省 " + d["0"] + "%。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a184939369 = messageFormatterFn((function(  ) {
  return function(d) { return "或"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b2068924249 = messageFormatterFn((function(  ) {
  return function(d) { return "其他方式登录"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b2068564835 = messageFormatterFn((function(  ) {
  return function(d) { return "其他方式注册"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a516336525 = messageFormatterFn((function(  ) {
  return function(d) { return "使用 Google 帐户注册"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b45251348 = messageFormatterFn((function(  ) {
  return function(d) { return "登录失败。请重试，或在此网站注册帐户以继续。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a2032624102 = messageFormatterFn((function(  ) {
  return function(d) { return "无法通过电话号码登录。请确保您的社交媒体帐户已关联了邮箱。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1603815202 = messageFormatterFn((function(  ) {
  return function(d) { return "免费成为会员，预订数千家酒店可省 " + d["0"] + "% 或更多。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1817409597 = messageFormatterFn((function(  ) {
  return function(d) { return "使用 Google 帐户登录"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1734647400 = messageFormatterFn((function(  ) {
  return function(d) { return "使用 NAVER 帐户登录"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1994113826 = messageFormatterFn((function(  ) {
  return function(d) { return "您已超过登录尝试次数上限。请稍后再试。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b73137483 = messageFormatterFn((function(  ) {
  return function(d) { return "使用指纹/面部识别登录"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a680318539 = messageFormatterFn((function(  ) {
  return function(d) { return "使用指纹/面部识别登录帐户，无需输入密码。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a422462968 = messageFormatterFn((function(  ) {
  return function(d) { return "立即开始"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1288889144 = messageFormatterFn((function(  ) {
  return function(d) { return "稍后再提醒"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1814632722 = messageFormatterFn((function(  ) {
  return function(d) { return "成功！"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1192720088 = messageFormatterFn((function(  ) {
  return function(d) { return "已启用指纹/面部识别登录。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1697508272 = messageFormatterFn((function(  ) {
  return function(d) { return "使用指纹/面部识别登录"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1740114219 = messageFormatterFn((function(  ) {
  return function(d) { return "使用密码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1437708704 = messageFormatterFn((function(  ) {
  return function(d) { return "使用指纹/面部识别"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1739976359 = messageFormatterFn((function(  ) {
  return function(d) { return "更新密码以继续"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b2089065547 = messageFormatterFn((function(  ) {
  return function(d) { return "如需登录帐户，请重置密码。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1044957643 = messageFormatterFn((function(  ) {
  return function(d) { return "重置密码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1330541397 = messageFormatterFn((function(  ) {
  return function(d) { return "会员礼遇等您来拿"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a2019109521 = messageFormatterFn((function(  ) {
  return function(d) { return "我们为您送上价值 $" + d["0"] + " 的积分，助您早日开启探险之旅！"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1408880449 = messageFormatterFn((function(  ) {
  return function(d) { return "您可以立即在帐户中查看积分，并且在第一次预订时即可使用，请记得在付款时留意使用积分的选项。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a522900397 = messageFormatterFn((function(  ) {
  return function(d) { return "您现在已是 Expedia 会员。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b546723037 = messageFormatterFn((function(  ) {
  return function(d) { return "赶快预订，立享会员价，既能省钱又能攒积分。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1116286744 = messageFormatterFn((function(  ) {
  return function(d) { return "登录或注册帐户"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1915049154 = messageFormatterFn((function(  ) {
  return function(d) { return "免费成为会员，预订数千家酒店平均可省 " + d["0"] + "%。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b721144384 = messageFormatterFn((function(  ) {
  return function(d) { return "继续即表示您已阅读并同意我们的<a href=" + d["1"] + " " + d["3"] + ">条款和条件</a>及<a href=" + d["2"] + " " + d["4"] + ">隐私声明</a>。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b541461854 = messageFormatterFn((function(  ) {
  return function(d) { return "继续即表示您已阅读并同意我们的<a href=" + d["1"] + " " + d["5"] + ">条款和条件</a>、<a href=" + d["2"] + " " + d["6"] + ">隐私声明</a>及 <a href=" + d["3"] + " " + d["7"] + ">" + d["4"] + " 条款和条件</a>。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1946984893 = messageFormatterFn((function(  ) {
  return function(d) { return "继续即表示您已阅读并同意我们的<a href=" + d["1"] + " " + d["4"] + ">条款和条件</a>、<a href=" + d["2"] + " " + d["5"] + ">隐私声明</a>及 <a href=" + d["3"] + " " + d["6"] + ">One Key 旅行奖励计划条款和条件</a>。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1946384455 = messageFormatterFn((function(  ) {
  return function(d) { return "邮箱"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a769161153 = messageFormatterFn((function(  ) {
  return function(d) { return "请输入有效的邮箱地址"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1735724412 = messageFormatterFn((function(  ) {
  return function(d) { return "Google"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a953547729 = messageFormatterFn((function(  ) {
  return function(d) { return "Facebook"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1160404293 = messageFormatterFn((function(  ) {
  return function(d) { return "Apple"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1311740734 = messageFormatterFn((function(  ) {
  return function(d) { return "仅适用于个人设备。为确保帐户安全，请勿在共享设备上勾选此项。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b935645487 = messageFormatterFn((function(  ) {
  return function(d) { return "您尝试登录的次数过多。请在 " + d["0"] + " 分钟后再次尝试。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b594276877 = messageFormatterFn((function(  ) {
  return function(d) { return "您尝试登录的次数过多。请在 " + d["0"] + " 分钟后再次尝试。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b589381543 = messageFormatterFn((function(  ) {
  return function(d) { return "您尝试登录的次数过多。请在 " + d["0"] + " 分钟后再次尝试。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b602839387 = messageFormatterFn((function(  ) {
  return function(d) { return "您尝试登录的次数过多。请在 " + d["0"] + " 分钟后再次尝试。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1311628088 = messageFormatterFn((function(  ) {
  return function(d) { return "您尝试登录的次数过多。请在 " + d["0"] + " 分钟后再次尝试。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a307134365 = messageFormatterFn((function(  ) {
  return function(d) { return "您尝试登录的次数过多。请在 " + d["0"] + " 分钟后再次尝试。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1338454452 = messageFormatterFn((function(  ) {
  return function(d) { return "使用同一帐户在 Expedia、Hotels.com 好订网和 Vrbo 解锁丰厚奖励。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1864341868 = messageFormatterFn((function(  ) {
  return function(d) { return "使用同一帐户在 Expedia、Hotels.com 好订网和 Vrbo 解锁旅行世界。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1546463629 = messageFormatterFn((function(  ) {
  return function(d) { return "浏览及收藏住宿，与旅伴一起做计划，查看您的预订详情。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b462950414 = messageFormatterFn((function(  ) {
  return function(d) { return "您的帐户在例行安全检查中被暂停使用。您的信息很安全，但需要重置密码。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b72515266 = messageFormatterFn((function(  ) {
  return function(d) { return "登录帐户预订住宿，获得 OneKeyCash 奖励金"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1155148714 = messageFormatterFn((function(  ) {
  return function(d) { return "确认是您本人"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a791068356 = messageFormatterFn((function(  ) {
  return function(d) { return "请输入我们发送至您邮箱的验证码。如果收件箱内没有，请检查垃圾邮件。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1624729640 = messageFormatterFn((function(  ) {
  return function(d) { return "确认您的邮箱地址"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a587710898 = messageFormatterFn((function(  ) {
  return function(d) { return "请输入我们发送至 " + d["0"] + " 的验证码以继续。如果收件箱内没有，请检查垃圾邮件。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b419890540 = messageFormatterFn((function(  ) {
  return function(d) { return "6 位验证码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1917660652 = messageFormatterFn((function(  ) {
  return function(d) { return "重新发送验证码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1466160491 = messageFormatterFn((function(  ) {
  return function(d) { return "（" + d["0"] + " 秒后）"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b204669619 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " 秒后重新发送验证码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a77785693 = messageFormatterFn((function(  ) {
  return function(d) { return "没有收到邮件？"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b502592709 = messageFormatterFn((function(  ) {
  return function(d) { return "您可以在 " + d["0"] + " 秒后再次获取验证码。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1362372658 = messageFormatterFn((function(  ) {
  return function(d) { return "再次获取验证码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1762715816 = messageFormatterFn((function(  ) {
  return function(d) { return "我们向您的收件箱发送了新的 6 位数验证码。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1573583395 = messageFormatterFn((function(  ) {
  return function(d) { return "或者输入密码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b2077280386 = messageFormatterFn((function(  ) {
  return function(d) { return "验证码无效，请重试"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1109188268 = messageFormatterFn((function(  ) {
  return function(d) { return "验证码过期，请重新发送并重试"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a2049120417 = messageFormatterFn((function(  ) {
  return function(d) { return "如果收件箱内没有，请检查垃圾邮件。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a7796040 = messageFormatterFn((function(  ) {
  return function(d) { return "我们已进行体验更新，需要确认您的邮箱地址。请输入您收件箱收到的安全验证码。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1114983241 = messageFormatterFn((function(  ) {
  return function(d) { return "我们这里出现了一点问题。请再试一次。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1687584128 = messageFormatterFn((function(  ) {
  return function(d) { return "如需更新您的登录方式，请输入我们发送至您邮箱的验证码。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b39468282 = messageFormatterFn((function(  ) {
  return function(d) { return "请输入密码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1121991873 = messageFormatterFn((function(  ) {
  return function(d) { return "通过邮件发送验证码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1567781185 = messageFormatterFn((function(  ) {
  return function(d) { return "邮箱地址和密码不匹配"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b716794614 = messageFormatterFn((function(  ) {
  return function(d) { return "创建密码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a282688628 = messageFormatterFn((function(  ) {
  return function(d) { return "创建密码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1694480870 = messageFormatterFn((function(  ) {
  return function(d) { return "您可以使用同一邮箱地址和密码登录 Expedia、Hotels.com 好订网和 Vrbo。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1712386426 = messageFormatterFn((function(  ) {
  return function(d) { return "创建密码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1791712867 = messageFormatterFn((function(  ) {
  return function(d) { return "除其他安全登录方式外，您也可以设置密码。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1680278424 = messageFormatterFn((function(  ) {
  return function(d) { return "设置新密码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1767407490 = messageFormatterFn((function(  ) {
  return function(d) { return "设置新密码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b914082792 = messageFormatterFn((function(  ) {
  return function(d) { return "现在，您可以在 Expedia、Hotels.com 好订网和 Vrbo 共用一个帐户登录。为您的合并帐户创建一个新的安全密码。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1164381688 = messageFormatterFn((function(  ) {
  return function(d) { return "创建密码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a644383584 = messageFormatterFn((function(  ) {
  return function(d) { return "更改密码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1419989328 = messageFormatterFn((function(  ) {
  return function(d) { return "使用独特、保密力度大的密码。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1952590288 = messageFormatterFn((function(  ) {
  return function(d) { return "更新密码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b42375363 = messageFormatterFn((function(  ) {
  return function(d) { return "我们无法更改您的密码。请再试一次。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b553027173 = messageFormatterFn((function(  ) {
  return function(d) { return "忘记密码"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1484499105 = messageFormatterFn((function(  ) {
  return function(d) { return "请输入您的邮箱地址，我们将为您发送用于登录的验证码。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a748828001 = messageFormatterFn((function(  ) {
  return function(d) { return "发送电子邮件"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a85484589 = messageFormatterFn((function(  ) {
  return function(d) { return "联系我们"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1066942366 = messageFormatterFn((function(  ) {
  return function(d) { return "删除数据"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1738382057 = messageFormatterFn((function(  ) {
  return function(d) { return "关闭"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a88191931 = messageFormatterFn((function(  ) {
  return function(d) { return "请稍候，正在检查您的帐户。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1898389540 = messageFormatterFn((function(  ) {
  return function(d) { return "注销帐户"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b546973816 = messageFormatterFn((function(  ) {
  return function(d) { return "确定"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a176685756 = messageFormatterFn((function(  ) {
  return function(d) { return "抱歉，在您的行程完成之前，您无法注销帐户。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b273532323 = messageFormatterFn((function(  ) {
  return function(d) { return "为确保旅途顺利，您需要保留此帐户，以防需要在最后时限变更时获得客服中心的帮助。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a267310038 = messageFormatterFn((function(  ) {
  return function(d) { return "抱歉，您需要先注销您的 Vrbo 房东帐户。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a417176161 = messageFormatterFn((function(  ) {
  return function(d) { return "请访问我们网站或 App 上的帮助中心，或直接联系客服以进行操作。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1560167407 = messageFormatterFn((function(  ) {
  return function(d) { return "请在行程结束后再试一次。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b889199826 = messageFormatterFn((function(  ) {
  return function(d) { return "请告知我们您想注销的原因"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1118442975 = messageFormatterFn((function(  ) {
  return function(d) { return "我收到太多电子邮件或通知"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1685904969 = messageFormatterFn((function(  ) {
  return function(d) { return "我有另一个 " + d["0"] + " 的帐户"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1621564110 = messageFormatterFn((function(  ) {
  return function(d) { return "我的旅行结束了，所以我不再需要此帐户"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b209882376 = messageFormatterFn((function(  ) {
  return function(d) { return "我在 " + d["0"] + " 的预订体验不太好"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1575626919 = messageFormatterFn((function(  ) {
  return function(d) { return "其他"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1495763146 = messageFormatterFn((function(  ) {
  return function(d) { return "关闭"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b678641091 = messageFormatterFn((function(  ) {
  return function(d) { return "提交"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1034250957 = messageFormatterFn((function(  ) {
  return function(d) { return "很遗憾得知您决定注销帐户。请您知晓以下信息："; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1643797728 = messageFormatterFn((function(  ) {
  return function(d) { return "您将永久失去 " + d["0"] + " Expedia Rewards 积分（价值 " + d["1"] + "）、代金券（价值 " + d["2"] + "）、优惠券、已保存的行程项目和帐户偏好。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1579544657 = messageFormatterFn((function(  ) {
  return function(d) { return "您将永久失去 " + d["0"] + " Expedia Rewards 积分（价值 " + d["1"] + "）、优惠券、已保存的行程项目和帐户偏好。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1645981715 = messageFormatterFn((function(  ) {
  return function(d) { return "您将永久失去行程记录、代金券和偏好设置。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a456727561 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com 好订网奖励：您将失去 " + d["0"] + " 晚奖励住宿（价值 " + d["1"] + "）和 " + d["2"] + " 个印章（平均价值 " + d["3"] + "）。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b278349606 = messageFormatterFn((function(  ) {
  return function(d) { return "您将永久失去代金券、优惠券、保存的行程项目和帐户偏好设置。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1882857342 = messageFormatterFn((function(  ) {
  return function(d) { return "您将永久失去 " + d["0"] + " CheapCash（价值 " + d["1"] + "）、代金券（价值 " + d["2"] + "）、优惠券、已保存的行程项目和帐户偏好。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b108711057 = messageFormatterFn((function(  ) {
  return function(d) { return "您将永久失去 " + d["0"] + " CheapCash（价值 " + d["1"] + "）、优惠券、已保存的行程项目和帐户偏好。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1922623482 = messageFormatterFn((function(  ) {
  return function(d) { return "您将永久失去 " + d["0"] + " Orbucks（价值 " + d["1"] + "）、代金券（价值 " + d["2"] + "）、优惠券、已保存的行程项目和帐户偏好。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1684188937 = messageFormatterFn((function(  ) {
  return function(d) { return "您将永久失去 " + d["0"] + " Orbucks（价值 " + d["1"] + "）、优惠券、已保存的行程项目和帐户偏好。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a95394400 = messageFormatterFn((function(  ) {
  return function(d) { return "您将永久失去 " + d["0"] + " MrJet Rewards（价值 " + d["1"] + "）、代金券（价值 " + d["2"] + "）、优惠券、已保存的行程项目和帐户偏好。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b192199983 = messageFormatterFn((function(  ) {
  return function(d) { return "您将永久失去 " + d["0"] + " MrJet Rewards（价值 " + d["1"] + "）、优惠券、已保存的行程项目和帐户偏好。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b733001054 = messageFormatterFn((function(  ) {
  return function(d) { return "您将永久失去 " + d["0"] + " BONUS+（价值 " + d["1"] + "）、代金券（价值 " + d["2"] + "）、优惠券、已保存的行程项目和帐户偏好。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a973747535 = messageFormatterFn((function(  ) {
  return function(d) { return "您将永久失去 " + d["0"] + " BONUS+（价值 " + d["1"] + "）、优惠券、已保存的行程项目和帐户偏好。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1315121452 = messageFormatterFn((function(  ) {
  return function(d) { return "您将永久失去优惠券、已保存的行程项目和帐户偏好。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1264476863 = messageFormatterFn((function(  ) {
  return function(d) { return "您将永久失去代金券（价值 " + d["0"] + "）、优惠券、已保存的行程项目和帐户偏好。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1322368683 = messageFormatterFn((function(  ) {
  return function(d) { return "为了履行法律义务，或在我们需要确立、行使或申辩法律索赔的情况下，我们可能会安全地保留一些信息，如您的交易记录。我们将安全地保留这些信息，一旦不再需要，将立即删除、匿名化处理或永久模糊处理。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b398468809 = messageFormatterFn((function(  ) {
  return function(d) { return "永久注销帐户"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1486816793 = messageFormatterFn((function(  ) {
  return function(d) { return "不要注销帐户"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1647257359 = messageFormatterFn((function(  ) {
  return function(d) { return "期待您再次光临"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b98462224 = messageFormatterFn((function(  ) {
  return function(d) { return "您的删除请求可能需要几周的时间来处理，所以在我们的系统更新期间，您可能会继续收到通信。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1213171958 = messageFormatterFn((function(  ) {
  return function(d) { return "请重试"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1269335337 = messageFormatterFn((function(  ) {
  return function(d) { return "发生系统错误。重新提交删除帐户的请求，或在几分钟后重试。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b118612641 = messageFormatterFn((function(  ) {
  return function(d) { return "关闭"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b945628552 = messageFormatterFn((function(  ) {
  return function(d) { return "您的旅行证件上所使用的姓名是什么？"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1522117288 = messageFormatterFn((function(  ) {
  return function(d) { return "请将帐户中的姓名设置为旅行证件（如：护照）上的姓名。以便您之后进行预订。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1127214278 = messageFormatterFn((function(  ) {
  return function(d) { return "接收 " + d["0"] + " 通过邮件发送的优惠、促销及其他信息。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1424677015 = messageFormatterFn((function(  ) {
  return function(d) { return "接收 " + d["0"] + " 通过邮件发送的优惠、促销及其他信息。您可以随时退订推广邮件。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b129831132 = messageFormatterFn((function(  ) {
  return function(d) { return "帐户信息"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1914252666 = messageFormatterFn((function(  ) {
  return function(d) { return "接收有关优惠、特价和其他信息的 " + d["0"] + " 邮件您可以随时选择退订。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1646767830 = messageFormatterFn((function(  ) {
  return function(d) { return "为您提供丰富信息"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1395456720 = messageFormatterFn((function(  ) {
  return function(d) { return "营销许可"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1770879649 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia Rewards"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b2132922525 = messageFormatterFn((function(  ) {
  return function(d) { return "CheapCash"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1951019931 = messageFormatterFn((function(  ) {
  return function(d) { return "Orbitz Rewards"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a786182659 = messageFormatterFn((function(  ) {
  return function(d) { return "BONUS+"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a650499743 = messageFormatterFn((function(  ) {
  return function(d) { return "MrJet"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a485124010 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com 好订网奖励计划"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1359662622 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a38132687 = messageFormatterFn((function(  ) {
  return function(d) { return "抱歉，您需要等到您的行程完成"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1001031649 = messageFormatterFn((function(  ) {
  return function(d) { return "抱歉，您需要等到您即将到来的行程结束"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b28968071 = messageFormatterFn((function(  ) {
  return function(d) { return "您的帐户允许您访问详细预订信息，并在需要时联系支持人员。请在行程结束后再试一次。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1898965771 = messageFormatterFn((function(  ) {
  return function(d) { return "您可以通过帐户访问详细预订信息，并在需要时联系支持人员。请在行程结束后重试。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1413892 = messageFormatterFn((function(  ) {
  return function(d) { return "抱歉，目前无法注销您的帐户"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1522944046 = messageFormatterFn((function(  ) {
  return function(d) { return "此帐户还用于托管 Vrbo 上的住宿。您需要登录 Vrbo 业主 App 或网站以删除您的生效房源，然后才能删除您的帐户。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1339825857 = messageFormatterFn((function(  ) {
  return function(d) { return "请告诉我们您注销帐户的原因。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b2085711222 = messageFormatterFn((function(  ) {
  return function(d) { return "我有使用其他邮箱注册的帐户"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1084412149 = messageFormatterFn((function(  ) {
  return function(d) { return "我的预订体验不好"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1224789216 = messageFormatterFn((function(  ) {
  return function(d) { return "很遗憾您选择注销帐户。请注意，删除帐户是不可逆的操作，会影响您在 Expedia、Hotels.com 好订网和 Vrbo 的数据。请您知晓以下信息："; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1203614741 = messageFormatterFn((function(  ) {
  return function(d) { return "很遗憾您选择注销帐户。请注意，删除帐户是不可逆的操作，会影响您在 Expedia、Wotif、Hotels.com 好订网和 Vrbo 的数据。请您知晓以下信息："; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1164918172 = messageFormatterFn((function(  ) {
  return function(d) { return "您在 Expedia、Hotels.com 好订网和 Vrbo 上的帐户历史记录、首选项和保存的项目将会永久丢失。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1351059815 = messageFormatterFn((function(  ) {
  return function(d) { return "您在 Expedia、Wotif、Hotels.com 好订网和 Vrbo 上的帐户历史记录、首选项和保存的项目将会永久丢失。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1037458096 = messageFormatterFn((function(  ) {
  return function(d) { return "您的所有 OneKeyCash 奖励金都将永久丢失，包括任何未入账的 OneKeyCash 奖励金、您的 One Key 旅行奖励计划等级及其所有礼遇。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b553519546 = messageFormatterFn((function(  ) {
  return function(d) { return "您的任何未入账的 OneKeyCash 奖励金、您的 One Key 旅行奖励计划等级及其所有礼遇都将永久丢失。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1473617179 = messageFormatterFn((function(  ) {
  return function(d) { return "您价值 " + d["0"] + " 的 OneKeyCash 奖励金、任何未入账的 OneKeyCash 奖励金、您的 One Key 旅行奖励计划等级及其所有礼遇都将永久丢失。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a105618193 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com 好订网奖励信用卡持卡人将不会再基于卡活动收到奖励。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1708366382 = messageFormatterFn((function(  ) {
  return function(d) { return "您将永久丢失所有 Expedia Rewards 积分（包括所有已确认和未入账的 Expedia Rewards 积分）、Hotels.com 好订网奖励印章和奖励住宿及奖励等级。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b879853532 = messageFormatterFn((function(  ) {
  return function(d) { return "您将永久丢失任何未入账的 Expedia Rewards 积分、Hotels.com 好订网奖励印章和奖励住宿及奖励等级。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a1268078186 = messageFormatterFn((function(  ) {
  return function(d) { return "您将永久丢失 Expedia、Hotels.com 好订网或 Vrbo 的所有优惠券和代金券。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b922792011 = messageFormatterFn((function(  ) {
  return function(d) { return "您将永久丢失 Expedia、Wotif、Hotels.com 好订网或 Vrbo 的所有优惠券和代金券。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a233388035 = messageFormatterFn((function(  ) {
  return function(d) { return "您的 Expedia、Hotels.com 好订网和 Vrbo 帐户的删除请求可能需要几周的时间来处理，所以在我们的系统更新期间，您可能会继续收到通信。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a952097422 = messageFormatterFn((function(  ) {
  return function(d) { return "您的 Expedia、Wotif、Hotels.com 好订网和 Vrbo 帐户的删除请求可能需要几周的时间来处理，所以在我们的系统更新期间，您可能会继续收到通信。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b432123592 = messageFormatterFn((function(  ) {
  return function(d) { return "删除帐户后，您的 One Key Card 将被停用，并且不会再从任何预订中获得 OneKeyCash 奖励金。富国银行 (Wells Fargo) 将与您联系，确认您的银行卡已停用。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1151517198 = messageFormatterFn((function(  ) {
  return function(d) { return "删除帐户后，您的 One Key+ Card 将被停用，并且不会再从任何预订中获得 OneKeyCash 奖励金。富国银行 (Wells Fargo) 将与您联系，确认您的银行卡已停用。"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a993866361 = messageFormatterFn((function(  ) {
  return function(d) { return "登录或注册帐户，获得行程带来的 OneKeyCash 奖励金"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b251482751 = messageFormatterFn((function(  ) {
  return function(d) { return "登录或注册帐户，获得该住宿预订带来的奖励"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1223735240 = messageFormatterFn((function(  ) {
  return function(d) { return "以访客身份结算"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b1606304426 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " 帐户登录：添加手机号"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b404035814 = messageFormatterFn((function(  ) {
  return function(d) { return "出错了"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b460637460 = messageFormatterFn((function(  ) {
  return function(d) { return "请尝试重新登录"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.b33126557 = messageFormatterFn((function(  ) {
  return function(d) { return "确定"; }
})(), Globalize("zh-CN").pluralGenerator({}));
Globalize.a793557493 = dateToPartsFormatterFn({"2":Globalize("zh-CN").numberFormatter({"raw":"00"}),"4":Globalize("zh-CN").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.b320988875 = dateToPartsFormatterFn({"2":Globalize("zh-CN").numberFormatter({"raw":"00"}),"4":Globalize("zh-CN").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.a454282952 = dateToPartsFormatterFn({"1":Globalize("zh-CN").numberFormatter({"raw":"0"}),"4":Globalize("zh-CN").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.b668171006 = dateToPartsFormatterFn({"1":Globalize("zh-CN").numberFormatter({"raw":"0"}),"4":Globalize("zh-CN").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.b266847851 = dateToPartsFormatterFn({"2":Globalize("zh-CN").numberFormatter({"raw":"00"}),"4":Globalize("zh-CN").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.b1092013878 = dateToPartsFormatterFn({"1":Globalize("zh-CN").numberFormatter({"raw":"0"}),"4":Globalize("zh-CN").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.a1530874165 = dateToPartsFormatterFn({"2":Globalize("zh-CN").numberFormatter({"raw":"00"}),"4":Globalize("zh-CN").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.b212706827 = dateToPartsFormatterFn({"2":Globalize("zh-CN").numberFormatter({"raw":"00"}),"4":Globalize("zh-CN").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.a316787445 = dateToPartsFormatterFn({"2":Globalize("zh-CN").numberFormatter({"raw":"00"}),"4":Globalize("zh-CN").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.a212711560 = dateToPartsFormatterFn({"1":Globalize("zh-CN").numberFormatter({"raw":"0"}),"4":Globalize("zh-CN").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.b985267819 = dateToPartsFormatterFn({"2":Globalize("zh-CN").numberFormatter({"raw":"00"}),"4":Globalize("zh-CN").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.b1260760758 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"日","mon":"一","tue":"二","wed":"三","thu":"四","fri":"五","sat":"六"}}}});
Globalize.b179247883 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"星期日","mon":"星期一","tue":"星期二","wed":"星期三","thu":"星期四","fri":"星期五","sat":"星期六"}}}});
Globalize.b1432493323 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"一月","2":"二月","3":"三月","4":"四月","5":"五月","6":"六月","7":"七月","8":"八月","9":"九月","10":"十月","11":"十一月","12":"十二月"}}}});
Globalize.b1012773365 = dateToPartsFormatterFn({"1":Globalize("zh-CN").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.b527235800 = dateToPartsFormatterFn({"1":Globalize("zh-CN").numberFormatter({"raw":"0"}),"2":Globalize("zh-CN").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.a1124499609 = dateToPartsFormatterFn({"1":Globalize("zh-CN").numberFormatter({"raw":"0"})}, {"pattern":"M月d日","timeSeparator":":"});
Globalize.a480388368 = dateToPartsFormatterFn({"1":Globalize("zh-CN").numberFormatter({"raw":"0"})}, {"pattern":"M月d日","timeSeparator":":"});
Globalize.b230808667 = dateToPartsFormatterFn({"1":Globalize("zh-CN").numberFormatter({"raw":"0"})}, {"pattern":"y年MMMM月d日","timeSeparator":":","months":{"M":{"4":{"1":"一月","2":"二月","3":"三月","4":"四月","5":"五月","6":"六月","7":"七月","8":"八月","9":"九月","10":"十月","11":"十一月","12":"十二月"}}}});
Globalize.b146053413 = dateToPartsFormatterFn({"1":Globalize("zh-CN").numberFormatter({"raw":"0"})}, {"pattern":"y年M月","timeSeparator":":"});
Globalize.b145368220 = dateToPartsFormatterFn({"1":Globalize("zh-CN").numberFormatter({"raw":"0"})}, {"pattern":"y年M月d日","timeSeparator":":"});
Globalize.b1431002023 = dateToPartsFormatterFn({"1":Globalize("zh-CN").numberFormatter({"raw":"0"})}, {"pattern":"MMM月d日EEEE","timeSeparator":":","months":{"M":{"3":{"1":"1月","2":"2月","3":"3月","4":"4月","5":"5月","6":"6月","7":"7月","8":"8月","9":"9月","10":"10月","11":"11月","12":"12月"}}},"days":{"E":{"4":{"sun":"星期日","mon":"星期一","tue":"星期二","wed":"星期三","thu":"星期四","fri":"星期五","sat":"星期六"}}}});
Globalize.a473000200 = dateToPartsFormatterFn({"1":Globalize("zh-CN").numberFormatter({"raw":"0"})}, {"pattern":"M月d日E","timeSeparator":":","days":{"E":{"1":{"sun":"周日","mon":"周一","tue":"周二","wed":"周三","thu":"周四","fri":"周五","sat":"周六"}}}});
Globalize.a1172271244 = dateFormatterFn(Globalize("zh-CN").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.a57724876 = dateFormatterFn(Globalize("zh-CN").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.b2025767137 = dateFormatterFn(Globalize("zh-CN").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.a1146746201 = dateFormatterFn(Globalize("zh-CN").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.a111865900 = dateFormatterFn(Globalize("zh-CN").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.a722903329 = dateFormatterFn(Globalize("zh-CN").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.a1909587916 = dateFormatterFn(Globalize("zh-CN").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.a166006924 = dateFormatterFn(Globalize("zh-CN").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.a695501196 = dateFormatterFn(Globalize("zh-CN").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.a2027628767 = dateFormatterFn(Globalize("zh-CN").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.b606554068 = dateFormatterFn(Globalize("zh-CN").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b1411934125 = dateFormatterFn(Globalize("zh-CN").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.b1015408436 = dateFormatterFn(Globalize("zh-CN").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.a2026313420 = dateFormatterFn(Globalize("zh-CN").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.b429489772 = dateFormatterFn(Globalize("zh-CN").dateToPartsFormatter({"raw":"d"}));
Globalize.b918642881 = dateFormatterFn(Globalize("zh-CN").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a1552358178 = dateFormatterFn(Globalize("zh-CN").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.a859102119 = dateFormatterFn(Globalize("zh-CN").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.b1375584274 = dateFormatterFn(Globalize("zh-CN").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.a232660338 = dateFormatterFn(Globalize("zh-CN").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.a233345531 = dateFormatterFn(Globalize("zh-CN").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.b2048732574 = dateFormatterFn(Globalize("zh-CN").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.a851713951 = dateFormatterFn(Globalize("zh-CN").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.b1508634309 = dateParserFn(Globalize("zh-CN").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.a1671786619 = dateParserFn(Globalize("zh-CN").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.a1479819150 = dateParserFn(Globalize("zh-CN").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.a357365192 = dateParserFn(Globalize("zh-CN").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.a1725927643 = dateParserFn(Globalize("zh-CN").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.b66477680 = dateParserFn(Globalize("zh-CN").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.b771317637 = dateParserFn(Globalize("zh-CN").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.a1780068667 = dateParserFn(Globalize("zh-CN").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.b1985404357 = dateParserFn(Globalize("zh-CN").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.a1238247758 = dateParserFn(Globalize("zh-CN").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.a1007507675 = dateParserFn(Globalize("zh-CN").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.a394200644 = dateParserFn(Globalize("zh-CN").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^日/],["mon",/^一/],["tue",/^二/],["wed",/^三/],["thu",/^四/],["fri",/^五/],["sat",/^六/]]});
Globalize.b1926977349 = dateParserFn(Globalize("zh-CN").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["sun",/^星期日/],["mon",/^星期一/],["tue",/^星期二/],["wed",/^星期三/],["thu",/^星期四/],["fri",/^星期五/],["sat",/^星期六/]]});
Globalize.a1114744507 = dateParserFn(Globalize("zh-CN").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["11",/^十一月/],["12",/^十二月/],["1",/^一月/],["2",/^二月/],["3",/^三月/],["4",/^四月/],["5",/^五月/],["6",/^六月/],["7",/^七月/],["8",/^八月/],["9",/^九月/],["10",/^十月/]]});
Globalize.b1987276795 = dateParserFn(Globalize("zh-CN").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d","digitsRe":/\d/});
Globalize.b763039890 = dateParserFn(Globalize("zh-CN").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b1443616621 = dateParserFn(Globalize("zh-CN").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"M月d日","digitsRe":/\d/});
Globalize.b1821803434 = dateParserFn(Globalize("zh-CN").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"M月d日","digitsRe":/\d/});
Globalize.a1415689503 = dateParserFn(Globalize("zh-CN").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"y年MMMM月d日","digitsRe":/\d/,"gregorian/months/format/wide":[["11",/^十一月/],["12",/^十二月/],["1",/^一月/],["2",/^二月/],["3",/^三月/],["4",/^四月/],["5",/^五月/],["6",/^六月/],["7",/^七月/],["8",/^八月/],["9",/^九月/],["10",/^十月/]]});
Globalize.a1846722081 = dateParserFn(Globalize("zh-CN").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"y年M月","digitsRe":/\d/});
Globalize.a1847407274 = dateParserFn(Globalize("zh-CN").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"y年M月d日","digitsRe":/\d/});
Globalize.a305774419 = dateParserFn(Globalize("zh-CN").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MMM月d日EEEE","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["10",/^10月/],["11",/^11月/],["12",/^12月/],["1",/^1月/],["2",/^2月/],["3",/^3月/],["4",/^4月/],["5",/^5月/],["6",/^6月/],["7",/^7月/],["8",/^8月/],["9",/^9月/]],"gregorian/days/format/wide":[["sun",/^星期日/],["mon",/^星期一/],["tue",/^星期二/],["wed",/^星期三/],["thu",/^星期四/],["fri",/^星期五/],["sat",/^星期六/]]});
Globalize.b1829191602 = dateParserFn(Globalize("zh-CN").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"M月d日E","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["sun",/^周日/],["mon",/^周一/],["tue",/^周二/],["wed",/^周三/],["thu",/^周四/],["fri",/^周五/],["sat",/^周六/]]});
module.exports = Globalize;
